import { render } from "./PortalInstitutionalFooter.vue?vue&type=template&id=0b7366c0&scoped=true"
import script from "./PortalInstitutionalFooter.vue?vue&type=script&lang=js"
export * from "./PortalInstitutionalFooter.vue?vue&type=script&lang=js"

import "./PortalInstitutionalFooter.vue?vue&type=style&index=0&id=0b7366c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7366c0"]])

export default __exports__